module.exports = __webpack_public_path__ + "img/orderedlist.fad5759f.svg";